import getAddressDetailsFields from './fields/addressDetails.fields'
import communicationFields from './fields/communication.fields'
import getCustomerSalesAreaFields from './fields/customerSalesArea.fields'
import getSalesAreaTaxFields from './fields/salesAreaTax.fields'
import getAbacusSettingsFields from './fields/abacusSettings.fields'

const getBillingFormFields = (
    {
        setAutocomplete,
        currentPlaceId,
        value,
        isGoogleMapsServiceLoaded,
        getAllowedValues,
        isNew,
        disabled,
    },
) => {
    return [
        getAddressDetailsFields({
            setAutocomplete,
            currentPlaceId,
            value,
            isGoogleMapsServiceLoaded,
        }),
        communicationFields,
        getCustomerSalesAreaFields(getAllowedValues),
        getSalesAreaTaxFields(getAllowedValues),
        getAbacusSettingsFields({
            isNew,
            disabled,
        }),
    ]
}

export default getBillingFormFields
